import $ from 'jquery';

$(document).ready(function () {
    var welcomeDataLoaded = false; // Flag to check if welcome data is loaded
    var welcomeEndpoint = '/accounts/welcome';
    var accountAreaMyAccount, accountAreaSignIn, accountAreaUserName, accountAreaDropdown, authenticatedLinks;

    function setVars() {
        accountAreaMyAccount = $('.accountArea__myAccount a');
        accountAreaSignIn = $('.accountArea__signIn');
        accountAreaUserName = $('.accountArea__userName');
        accountAreaDropdown = $('.accountArea__dropdownItems');
        authenticatedLinks = accountAreaDropdown.find('li').filter(function () {
            return !$(this).hasClass('accountArea__signIn') && !$(this).hasClass('accountArea__userName');
        });
    }

    function addEventListeners() {
        $(document).on('DOMContentLoaded', onLoad);
        accountAreaMyAccount.on('click', onAccountClick);
        $(document).on('click', onDocumentClick);
    }

    function onLoad() {
        hideDropdown(); // Initially hide the dropdown
        accountAreaSignIn.css('display', 'none'); // Initially hide sign in
        accountAreaUserName.css('display', 'none'); // Initially hide user name
        authenticatedLinks.css('display', 'none'); // Initially hide authenticated links
    }

    function onAccountClick(event) {
        event.preventDefault(); // Prevent default link behavior
        event.stopPropagation(); // Prevent click event from propagating to document
        if (!welcomeDataLoaded) {
            getWelcomeData();
        } else if (accountAreaDropdown.length) {
            toggleDropdown(accountAreaDropdown);
        }
    }

    function onDocumentClick(event) {
        if (accountAreaDropdown.length) {
            const isClickInside = accountAreaMyAccount[0].contains(event.target) || accountAreaDropdown[0].contains(event.target);
            if (!isClickInside) {
                hideDropdown();
            }
        }
    }

    function toggleDropdown(dropdown) {
        var displayValue = dropdown.css('display') === 'none' ? 'block' : 'none';
        dropdown.css('display', displayValue);
    }

    function hideDropdown() {
        if (accountAreaDropdown.length) {
            accountAreaDropdown.css('display', 'none');
        }
    }

    function getWelcomeData() {
        $.ajax({
            url: welcomeEndpoint,
            cache: false,
            type: "GET",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                welcomeDataLoaded = true; // Set flag to true once data is loaded
                if (response.IsAuthenticated) {
                    accountAreaSignIn.css('display', 'none'); // Hide sign in
                    accountAreaUserName.css('display', 'block'); // Show user name
                    setSignedInName(response);
                    authenticatedLinks.css('display', 'block'); // Show authenticated links
                } else {
                    accountAreaSignIn.css('display', 'block'); // Show sign in
                    accountAreaUserName.css('display', 'none'); // Hide user name
                    authenticatedLinks.css('display', 'none'); // Hide authenticated links
                }
                if (accountAreaDropdown.length) {
                    toggleDropdown(accountAreaDropdown); // Show the dropdown after loading data
                }
            },
            error: function () {
                welcomeDataLoaded = true; // Ensure flag is set even on error to prevent repeated calls
                if (accountAreaDropdown.length) {
                    toggleDropdown(accountAreaDropdown); // Show the dropdown regardless
                }
            }
        });
    }

    function setSignedInName(response) {
        var signedInNameElement = $('.signedInName');
        if (signedInNameElement.length) {
            signedInNameElement.html(`${response.FirstName} ${response.LastName}`);
        }
    }

    // Initialize
    setVars();
    addEventListeners();
    onLoad(); // Ensure initial load state is set
});



// WEBPACK FOOTER //
// ./components/ws-signup-welcome/scripts/signup-welcome.js